const FAQ = [
    {
        title: 'מי אנחנו',
        secondary: [
            {
                description:
                    'ארביטריפ היא חברת טכנולוגיה ישראלית הפועלת מאז 2015 בתחום התיירות.\n\n' +
                    'החברה פיתחה טכנולוגיה להזמנת חדרים המאפשרת לאתר את המלונות המתאימים ביותר לנסיעה על פי פרמטרים רבים, תוך הבטחה למציאת מחיר משתלם באמצעות נגישות למחירים סיטונאיים וסריקת היצע החדרים אצל ספקים שונים.\n\n' +
                    'החברה צמחה בעולם נסיעות העסקים ועובדת היום בהצלחה עם אלפי חברות בארץ ובעולם.\n\n' +
                    'לאחרונה החלה לפעול בתחום הנסיעות הפרטיות באמצעות הטכנולוגיה המתקדמת שפיתחה והכוח המסחרי הגדול שצברה בעולם העסקי.\n\n' +
                    'שיתוף הפעולה הייחודי עם אייר חיפה מלונות מאפשר ללקוחותיה להנות ממחירים מצוינים ושירות מעולה כחול-לבן.\n\n' +
                    'נשמח לעמוד לשירותכם!',
            },
        ],
    },
    {
        title: 'איך המחירים נמוכים כל כך, והאם הם כוללים מיסים?',
        secondary: [
            {
                title: 'כן, זו לא טעות - המחירים באמת נמוכים!',
                description:
                    'ארביטריפ צמחה בעולם נסיעות העסקים ועובדת בהצלחה עם אלפי חברות בארץ ובעולם. לארביטריפ יש טכנולוגיה ייחודית וכוח מסחרי משמעותי, מה שמבטיח שתקבלו מחירים מצוינים שניתן למצוא בד"כ רק אצל ארגון גדול.\n\nהמחירים המוצגים באייר חיפה מלונות כוללים את כל המיסים והחיובים, מלבד מיסים מקומיים ועמלות לתשלום ישירות במלון, כמפורט בעמוד ההצעה בעת ביצוע ההזמנה. כשמשווים את המחירים באייר חיפה מלונות לאתרי תיירות אחרים, חשוב להשוות את המחיר הסופי כולל כל המיסים והחיובים.\n\nבכל שאלה בנושא ניתן לפנות אלינו כמפורט בעמוד "צור קשר" ונשמח לעזור.',
            },
        ],
    },
    {
        title: 'כיצד מתבצע התשלום על ההזמנה?',
        secondary: [
            {
                title: 'התשלום הוא מיידי על מלוא סכום ההזמנה.',
                description:
                    'החיוב מתבצע על ידי ארביטריפ בשלב התשלום בתהליך ההזמנה. בשלב התשלום יוצגו אמצעי תשלום עבורך ולאחר ביצוע התשלום בהצלחה יתקבל אישור הזמנה. להזמנות הניתנות לביטול ללא עלות - אם תבקש ביטול עד לתאריך הביטול האחרון המצוין בהזמנה, ההזמנה תבוטל מיידית ותשלח הודעת ביטול.',
            },
        ],
    },
    {
        title: 'למי פונים בבירורים כספיים?',
        secondary: [
            {
                title: 'יש לך שאלה לגבי התשלום או אמצעי התשלום?',
                description:
                    'החיוב מתבצע על ידי ארביטריפ בשם אייר חיפה מלונות. לכל שאלה או בירור כספי יש לפנות לצוות התמיכה של ארביטריפ כמוגדר בעמוד "צור קשר".',
            },
        ],
    },
    {
        title: 'האם וכיצד ניתן לעדכן את שם ההזמנה ו/או תאריכי ההזמנה?',
        description: 'ישנן כמה אופציות',
        secondary: [
            {
                title: 'במידה וההזמנה עדיין ניתנת לביטול ללא עלות',
                description:
                    'יש לבצע הזמנה חדשה עם הפרטים המעודכנים. לאחר קבלת אישור על ההזמנה החדשה, ניתן לבטל את ההזמנה הישנה.',
            },
            {
                title: 'במידה וההזמנה הינה בסטטוס של דמי ביטול מלאים',
                description:
                    'יש ליצור קשר עם צוות התמיכה של ארביטריפ (כמוגדר בעמוד "צור קשר") ואנו ניצור קשר עם בית המלון ונשתדל לבצע את השינויים הרצויים. יש לקחת בחשבון שתהליך זה תלוי באישור בית המלון בלבד ולכן ייתכן וייקח כמה ימים לאישור אם בכלל.',
            },
        ],
    },
    {
        title: 'כיצד אוכל להוסיף לילה/לילות להזמנה?',
        secondary: [
            {
                title: 'במידה וההזמנה ניתנת לביטול ללא עלות',
                description: 'ניתן לבצע הזמנה חדשה עם התאריכים המעודכנים ולאחר אישורה לבטל את ההזמנה הישנה.',
            },
            {
                title: 'במידה וההזמנה המקורית אינה ניתנת לביטול או שמכל סיבה אחרת רוצים להוסיף על הקיים',
                description:
                    'יש לבצע הזמנה נוספת על הלילות המבוקשים לאותו סוג החדר המוזמן ולציין בהערות כי מדובר בהארכת הזמנה קיימת. צוות התמיכה של ארביטריפ יפנה ישירות אל בית המלון ויעדכן אותם על איחוד הזמנה קיימת על מנת למנוע מעבר בין חדרים. במידה ויוזמן סוג חדר שונה מסוג החדר המוגדר בהזמנה המקורית, יידרש הנוסע לעבור חדר במהלך שהותו.',
            },
        ],
    },
    {
        title: 'הזמנתי חדר בלבד ואני מעוניין להוסיף ארוחת בוקר - כיצד ניתן?',
        secondary: [
            {
                title: 'במידה וההזמנה ניתנת לביטול ללא עלות',
                description:
                    'ניתן לבצע הזמנה חדשה הכוללת ארוחת בוקר. לאחר אישור סופי על ההזמנה החדשה - ניתן לבטל את ההזמנה הישנה.',
            },
            {
                title: 'אחרת',
                description: 'ניתן לפנות ישירות לבית המלון לטיפול עצמאי בנושא (תשלום ישירות לבית המלון).',
            },
        ],
    },
    {
        title: 'כיצד ניתן לבטל הזמנה שביצעתי?',
        secondary: [
            {
                title: 'במידה וההזמנה ניתנת לביטול ללא עלות',
                description:
                    'ניתן לבטלה באופן עצמאי דרך המערכת: דרך עמוד "ההזמנות שלי", בחרו את ההזמנה הרצויה והלחיצו על "ביטול הזמנה".',
            },
            {
                title: 'במידה וההזמנה בסטטוס של דמי ביטול מלאים',
                description:
                    'יש לפנות לצוות התמיכה של ארביטריפ כמוגדר בעמוד "צור קשר" על מנת לפנות למלון לקבלת זיכוי חלקי/מלא. קחו בחשבון כי נעשה כמיטב יכולתנו, אך בסופו של דבר ההחלטה תלויה בבית המלון בלבד. רצוי לספק סיבה והוכחות לביטול על מנת שנוכל לספקם למלון עם הבקשה.',
            },
        ],
    },
    {
        title: 'אני לא מוצא מלון ספציפי במערכת - תוכלו לעזור לי?',
        secondary: [
            {
                description:
                    'במידה והמלון בתפוסה מלאה, הוא אינו יופיע בתוצאות. ניתן לשלוח אלינו, כמוגדר בעמוד "צור קשר", את שם בית המלון, תאריכים ומספר חדרים הדרושים ואנו נבצע בדיקה האם נוכל לבצע את ההזמנה עבורכם ישירות מבית המלון.',
            },
        ],
    },
    {
        title: 'היכן ניתן לצפות בחשבוניות עבור ההזמנות שלי?',
        secondary: [
            {
                title: 'החשבונית תישלח אליך במייל מ-ארביטריפ.',
            },
            {
                title: 'במידה ולא קיבלתם את החשבונית במייל',
                description: 'יש ליצור קשר עם צוות התמיכה של ארביטריפ כדי לבקש את החשבונית.',
            },
        ],
    },
    {
        title: 'הגעתי למלון ועודכנתי כי אני צריך לשלם על ההזמנה - מדוע זה קורה והאם תוכלו לעזור לי?',
        secondary: [
            {
                description:
                    'זהו תרחיש חריג אשר לא אמור לקרות. אנא צרו עימנו קשר במיידי ואנו ניצור קשר עם בית המלון ונוודא כי לא תחוייבו. מצב זה נוצר בעקבות קצר בתקשורת במערכות בית המלון. במידה ובכל זאת חוייבתם על ידי בית המלון - נבקש כי תעבירו לנו הוכחה על החיוב על מנת שנוכל להעבירה לבית המלון עם הבקשה לזיכוי. יש לקחת בחשבון כי הטיפול בנושאים אלו יכול להימשך זמן מה אצל בית המלון ואנו נדאג לעדכנכם בסיום הטיפול.\n\nשימו לב: עיבוד התשלום עבור הזמנות אייר חיפה מלונות מתבצע על ידי Arbitrip.',
            },
        ],
    },
    {
        title: "עשיתי צ'ק אאוט מוקדם מבית המלון - האם ניתן לקבל החזר?",
        secondary: [
            {
                title: 'במידה ואתם נאלצים לצאת מוקדם מבית המלון',
                description:
                    'נא עדכנו אותנו עם כל פרטי ההזמנה וגם את הסיבה לכך. אנו ניצור קשר עם בית המלון וננהל מולם מו"מ לגבי החזר אפשרי. חשוב לציין כי ההחזר אינו מובטח ותלוי בבית המלון בלבד. לקידום הנושא אנו ממליצים לפנות בנוסף לקבלה בבית המלון עם הבקשה ולהעביר אלינו את השם של הנציג אשר דיברתם והאם אישר/ סירב לבקשתכם.',
            },
        ],
    },
    {
        title: "אני צריך לעשות צ'ק אין מוקדם - איך ניתן להבטיח זאת?",
        secondary: [
            {
                description:
                    'רוב בתי המלון דורשים להזמין את הלילה הקודם על מנת לאפשר כניסה מוקדמת יותר (מהמופיע בתנאי המלון) לחדר. חשוב להזמין את אותו סוג חדר ולעדכן אותנו לגבי כך על מנת שנוכל לעדכן את בית המלון כי יש לשמור את החדר עבורכם. ללא הזמנה של הלילה הקודם - לא נוכל להבטיח את הכניסה המוקדמת שכן הדבר תלוי בזמינות החדרים בבית המלון בלבד.',
            },
        ],
    },
    {
        title: 'אני מגיע למלון מאוחר - איך ניתן להבטיח שהמלון ישמור את החדר עבורי?',
        secondary: [
            {
                title: 'מלון עלול לבטל הזמנה של אורח שמגיע מאוחר, ללא הודעה',
                description:
                    'במידה ואורח מגיע לאחר השעה 20:00 (או לאחר שעת הצ\'ק אין המאוחרת ביותר, כפי שמופיע בתנאי המלון), המלון עלול לבטל את ההזמנה. בכל מקרה של הגעה מאוחרת כזו, עליכם להודיע לנו כמופיע בעמוד "צור קשר" כדי שנוכל לידע את המלון בהגעה המאוחרת ולהבטיח שההזמנה לא תבוטל.',
            },
        ],
    },
    {
        title: 'איך אוכל לצרף את מספר חבר המועדון שלי עבור רשת מלונות להזמנה שאני מבצע דרך המערכת?',
        secondary: [
            {
                title: 'תוכלו לציין את מספר חבר המועדון בסעיף "בקשות מיוחדות" במעמד ההזמנה.',
                description:
                    'במידה וההזמנה כבר בוצעה, תוכלו להעבירו אלינו כמוגדר בעמוד "צור קשר" ונעביר את הבקשה לבית המלון. שימו לב כי מכיוון שההזמנה בוצעה דרך גורם שלישי - ברוב המקרים בית המלון לא יכיר בחברות המועדון בהקשר להזמנה.',
            },
        ],
    },
    {
        title: 'האם ניתן להזמין מלון בישראל?',
        secondary: [
            {
                description: 'בשלב הזה לא ניתן להזמין מלונות בישראל.',
            },
        ],
    },
];

module.exports = {
    FAQ,
};
